export enum ERequestHeaders {
    IP = 'x-request-ip', // attached in middleware
    USER_ID = 'x-request-id', // attached in middleware
    LANGUAGE = 'x-request-language', // attached in middleware
    SEARCH_PARAMS = 'search-params',
    USER_AGENT = 'user-agent',
    REQUEST_URL = 'request-url',
    PAGE_NAME = 'page-name',
    PATH_NAME = 'x-pathname',
    HREF = 'next-href',
    USER_AB_TYPE = 'user-ab-type'
}

export enum ELanguage {
    EN = 'en',
    VI = 'vi'
}

export enum EMode {
    STAGING = 'staging',
    RELEASE = 'release',
    PRODUCTION = 'production'
}

export enum EPages {
    JOB_DETAIL = 'jobDetail',
    SUCCESS_APPLY = 'successApply'
}
